export { PENDING_DOCUMENTS, APPROVALS, VERIFICATIONS, REVISIONS } from '@/entities/Document';
export { EXTERNAL_DOCUMENT_NAME_PREFIX } from '@/entities/Document';

// ==================== REVISION TRAINING (UI) ====================

export const REVISION_TRAINING_TYPE_LABELS: Record<string, string> = {
  ONBOARDING: 'Onboarding',
  ROLE_CHANGE: 'Alteração de função',
  SGQ_DOCUMENT_FOCAL: 'Documento do SGQ | Pontual',
  SGQ_DOCUMENT_HOMOLOGATION: 'Documento do SGQ | Fluxo de Homologação',
  OPEN_TRAINING: 'Treinamento aberto',
};

export const REVISION_TRAINING_SGQ_FLOW_LABEL: Record<string, string> = {
  SGQ_DOCUMENT_FOCAL: 'Pontual',
  SGQ_DOCUMENT_HOMOLOGATION: 'Fluxo de Homologação',
};

// ==================== TABLE HEADERS ====================

export const HEADERS = [
  'Nome do Documento',
  'Rev.',
  'Status',
  'Vigência',
  'Validade',
  'Formato',
  'Local HTM',
  'Módulo',
  'Ações',
];
